/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality. 
 */

import { createElement, modal, toggleFieldError } from "commonAssets/js/helpers"
import { instructions } from "./Html/instructions"
import { oopInstructions } from "./Html/oopInstructions"
import { trxAttestedTime } from "./Html/trxAttestedTime"
import { trxCaptionExLosses } from "./Html/trxCaptionExLosses"
import { trxCaptionOop } from "./Html/trxCaptionOop"
import { attestation } from "./Html/attestation"

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log('[Initiate claim]...')

    /**
     * Disable first and last name fields
     */

    document.querySelector("#first_name").value
        ? document.querySelector("#first_name").disabled = true
        : document.querySelector("#first_name").disabled = false
    document.querySelector("#last_name").value
        ? document.querySelector("#last_name").disabled = true
        : document.querySelector("#last_name").disabled = false

    /**
     * Claim field edits
     */
    const cashPaymentLabel = document.querySelector('label[for="checkbox-cash-payment_0"]')
    const cashPaymentString = 'a Residual Cash Payment of up to $550'
    cashPaymentLabel.innerHTML = cashPaymentLabel.innerHTML.replace(cashPaymentString, `<strong>${cashPaymentString}</strong>`)

    const idInsuranceLabel = document.querySelector('label[for="checkbox-id-insurance_0"]')
    const idInsuranceString = '10 years of identity theft protection and credit monitoring services'
    idInsuranceLabel.innerHTML = idInsuranceLabel.innerHTML.replace(idInsuranceString, `<strong>${idInsuranceString}</strong>`)

    /**
     * General instructions
     */

    const generalInstructions = document.querySelector("#generalInstructions > div")
    if (generalInstructions) {
        generalInstructions.innerHTML = instructions
    }

    /**
     * Out of Pocket (OOP) instructions
     */

    const oopPlaceholder = document.querySelector(".oop-placeholder")
    if (oopPlaceholder) {
        oopPlaceholder.innerHTML = oopInstructions
    }

    /**
     * Transaction tables
     */

    const trx_1 = document.querySelector("#transactions_1")
    if (trx_1) {
        trx_1.querySelectorAll('td').forEach(td => {
            td.classList.add('w-25')
        })
    }

    const trx_2 = document.querySelector("#transactions_2")
    if (trx_2) {
        trx_2.querySelectorAll('td').forEach(td => {
            td.classList.add('w-25')
        })
    }

    document.querySelector('td.transaction.text-action-taken').classList.add('w-75')
    document.querySelector('td.transaction.number-time-spent').classList.add('w-25')

    /**
     * Transaction Date OOP Controller
     */
    function trxOopController() {
        const trxDateOop = document.querySelectorAll('input[data-label="Date (OOP)"]')
        trxDateOop.forEach(input => {
            input.min = '2023-03-21' // Set the minimum date to the start of the incident
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            input.max = tomorrow.toISOString().split('T')[0] // Set the maximum date to tomorrow

            input.addEventListener('input', () => {
                const value = input.value
                if (value < input.min || value > input.max) {
                    // input.value = ''
                    toggleFieldError(input, true, 'Date must be between March 21, 2023 and October 15, 2025.')
                }
            })
        })

        const trxAmountOop = document.querySelectorAll('input[data-label="Amount (OOP)"]')
        // if over or under the limits, then set to empty
        trxAmountOop.forEach(input => {
            input.min = 0.01 // Minimum amount is $0.01
            input.max = 1000 // Maximum amount is $1,000
            input.step = 0.01 // Step is $0.01

            input.addEventListener('input', () => {
                const value = parseFloat(input.value)
                if (isNaN(value) || value < input.min || value > input.max) {
                    input.value = ''
                    toggleFieldError(input, true, 'Amount must be between $0.01 and $1,000.00.')
                }
            })
        })
    }
    const trxDateOopAddRowBtn = document.querySelector("#add_transactions_1")
    trxDateOopAddRowBtn.addEventListener('click', trxOopController)
    trxOopController() // fire off by default

    /**
     * Extraordinary Losses Controller
     */
    function trxExLossesController() {
        const trxDateExLosses = document.querySelectorAll('input[data-label="Date (Extraordinary)"]')
        trxDateExLosses.forEach(input => {
            input.min = '2023-03-21' // Set the minimum date to the start of the incident
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            input.max = tomorrow.toISOString().split('T')[0] // Set the maximum date to tomorrow 
            input.addEventListener('input', () => {
                const value = input.value
                if (value < input.min || value > input.max) {
                    // input.value = ''
                    toggleFieldError(input, true, 'Date must be between March 21, 2023 and October 15, 2025.')
                }
            })
        })
        const trxAmountExLosses = document.querySelectorAll('input[data-label="Amount (Extraordinary)"]')
        // if over or under the limits, then set to empty
        trxAmountExLosses.forEach(input => {
            input.min = 0.01 // Minimum amount is $0.01
            input.max = 10000 // Maximum amount is $10,000
            input.step = 0.01 // Step is $0.01
            input.addEventListener('input', () => {
                const value = parseFloat(input.value)
                if (isNaN(value) || value < input.min || value > input.max) {
                    input.value = ''
                    toggleFieldError(input, true, 'Amount must be between $0.01 and $10,000.00.')
                }
            })
        })
    }
    const trxDateExLossesAddRowBtn = document.querySelector("#add_transactions_2")
    trxDateExLossesAddRowBtn.addEventListener('click', trxExLossesController)
    trxExLossesController() // fire off by default

    /**
     * Time spent handling
     * This is a custom field that allows users to add the time spent in minutes
     * for each transaction up to 5 hours.
     */
    const attestedTimeAddRowBtn = document.querySelector("#add_transactions_3")
    attestedTimeAddRowBtn.addEventListener('click', timeSpentHelper)

    function timeSpentHelper() {
        const timeSpentFields = document.querySelectorAll('input[data-label="Time Spent (in Hours)"]')

        timeSpentFields.forEach(field => {
            if (field.hasAttribute('data-validation-attached')) {
                return
            }

            field.min = 1
            field.max = 5 // 5 hours in hours
            field.step = 1

            field.addEventListener('input', () => {
                const value = field.value
                if (value < 1 || value > 5) {
                    field.value = ''
                }
                // if there are decimal places, then set to empty
                if (value % 1 !== 0) {
                    field.value = ''
                }
            })
        })
    }

    timeSpentHelper() // fire off by default

    /**
     * Table captions
     */

    const oopCaption = document.querySelector("#transactions_1 > caption")
    if (oopCaption) {
        oopCaption.innerHTML = trxCaptionOop
    }

    const exLossesCaption = document.querySelector("#transactions_2 > caption")
    if (exLossesCaption) {
        exLossesCaption.innerHTML = trxCaptionExLosses
    }

    const attestedTimeCaption = document.querySelector("#transactions_3 > caption")
    if (attestedTimeCaption) {
        attestedTimeCaption.innerHTML = trxAttestedTime
    }

    /**
     * Transactional tables overall logic
     * This is to ensure that the transaction tables are properly initialized
     * and that the fields are properly validated.
     * 
     * Transactional table 1 is to handle Out of Pocket (OOP) expenses, and by 
     * default, enabled for the class member.
     * 
     * Transactional table 2 is to handle Extraordinary Losses, and by default,
     * is now ENABLED for all class members, allowing them to fill out either OOP
     * or Extraordinary expenses, or both (per PM requirement).
     * 
     * Transactional table 3 is to handle the time spent handling the claim, and
     * by default, is DISABLED for the class member, until properly fills in the
     * Extraordinary Losses table (at least the first row).
     */

    const transactions_1_table = document.querySelector("#transactions_1")
    const transactions_2_table = document.querySelector("#transactions_2")
    const transactions_3_table = document.querySelector("#transactions_3")

    /**
     * Transactional tables dependencies management
     * 
     * This function implements the table dependencies:
     * - Table 1 (OOP) is enabled by default
     * - Table 2 (Extraordinary) is also enabled by default (per PM's requirement to allow either/or)
     * - Table 3 (Time) is enabled only when Table 2 has at least one valid row
     */
    function updateTableDependencies() {
        // Define what constitutes a "valid row" for each table
        const isValidOOPRow = () => {
            // Always return true since we want Table 2 to be available regardless of OOP data
            // This is per the Project Manager's requirement to make OOP and EOOP both optional
            return true;

            // Legacy code kept for reference
            /*
            // Check for valid rows in the OOP table
            const rows = transactions_1_table.querySelectorAll('tbody tr')

            for (const row of rows) {
                const dateInput = row.querySelector('input[data-label="Date (OOP)"]')
                const amountInput = row.querySelector('input[data-label="Amount (OOP)"]')
                const descTextarea = row.querySelector('textarea')

                // Check if this row has all required fields filled out
                if (dateInput && dateInput.value &&
                    amountInput && amountInput.value &&
                    descTextarea && descTextarea.value.trim()) {
                    return true
                }
            }

            // Also check for fields by ID pattern
            const descFields = document.querySelectorAll('[id^="text-desc-oop__"]')
            const dateFields = document.querySelectorAll('[id^="date-date-oop__"]')
            const amountFields = document.querySelectorAll('[id^="number-amount-oop__"]')

            for (let i = 0; i < descFields.length; i++) {
                if (descFields[i].value.trim() &&
                    (i < dateFields.length && dateFields[i].value) &&
                    (i < amountFields.length && amountFields[i].value)) {
                    return true
                }
            }

            return false;
            */
        }

        const isValidExtraordinaryRow = () => {
            // Check for valid rows in the Extraordinary Losses table
            const rows = transactions_2_table.querySelectorAll('tbody tr')

            for (const row of rows) {
                const dateInput = row.querySelector('input[data-label="Date (Extraordinary)"]')
                const amountInput = row.querySelector('input[data-label="Amount (Extraordinary)"]')
                const descTextarea = row.querySelector('textarea')

                // Check if this row has all required fields filled out
                if (dateInput && dateInput.value &&
                    amountInput && amountInput.value &&
                    descTextarea && descTextarea.value.trim()) {
                    return true
                }
            }

            // Also check for fields by ID pattern
            const descFields = document.querySelectorAll('[id^="text-desc-extraordinary__"]')
            const dateFields = document.querySelectorAll('[id^="date-date-extraordinary__"]')
            const amountFields = document.querySelectorAll('[id^="number-amount-extraordinary__"]')

            for (let i = 0; i < descFields.length; i++) {
                if (descFields[i].value.trim() &&
                    (i < dateFields.length && dateFields[i].value) &&
                    (i < amountFields.length && amountFields[i].value)) {
                    return true
                }
            }

            return false
        }

        // Table 2 (Extraordinary Losses) is enabled only when Table 1 has at least one valid row
        const table2Enabled = isValidOOPRow()

        // Table 3 (Time Spent) is enabled only when Table 2 has at least one valid row
        const table3Enabled = isValidExtraordinaryRow()

        // Update table states
        if (!table2Enabled) {
            // Disable Table 2 inputs
            const table2Inputs = transactions_2_table.querySelectorAll('input, textarea, button')
            table2Inputs.forEach(input => {
                input.disabled = true
            })
            transactions_2_table.classList.add('disabled-table')
        } else {
            // Enable Table 2 inputs
            const table2Inputs = transactions_2_table.querySelectorAll('input, textarea, button')
            table2Inputs.forEach(input => {
                input.disabled = false
            })
            transactions_2_table.classList.remove('disabled-table')
        }

        if (!table3Enabled) {
            // Disable Table 3 inputs
            const table3Inputs = transactions_3_table.querySelectorAll('input, textarea, button')
            table3Inputs.forEach(input => {
                input.disabled = true
            })
            transactions_3_table.classList.add('disabled-table')
        } else {
            // Enable Table 3 inputs
            const table3Inputs = transactions_3_table.querySelectorAll('input, textarea, button')
            table3Inputs.forEach(input => {
                input.disabled = false
            })
            transactions_3_table.classList.remove('disabled-table')
        }
    }

    // Add CSS for disabled tables
    const style = document.createElement('style')
    style.textContent = `
        .disabled-table {
            opacity: 0.6;
            pointer-events: none;
        }
        .disabled-table caption {
            opacity: 0.6;
        }
        .disabled-table button {
            pointer-events: none;
        }
    `
    document.head.appendChild(style)

    // Set up event listeners to track changes in Table 1 and Table 2
    transactions_1_table.addEventListener('input', updateTableDependencies)
    transactions_2_table.addEventListener('input', updateTableDependencies)

    // Also update dependencies when add row buttons are clicked
    // Use existing button references from earlier in the code
    document.querySelector("#add_transactions_1").addEventListener('click', () => {
        setTimeout(updateTableDependencies, 100) // Allow time for DOM to update
    })

    document.querySelector("#add_transactions_2").addEventListener('click', () => {
        setTimeout(updateTableDependencies, 100) // Allow time for DOM to update
    })

    /**
     * Attestation
     */

    const attestationParagraphElement = document.querySelector("#certification > p")
    if (attestationParagraphElement) {
        attestationParagraphElement.remove()
    }

    const attestationTitleElement = document.querySelector("#certification > div.formTitle")
    const attestationMessageElement = createElement('div', {
        class: 'mb-3'
    }, [], attestation)
    attestationTitleElement.insertAdjacentElement('afterend', attestationMessageElement)

    const checkboxPlaceholder = document.querySelector("#checkboxPlaceholder")
    if (checkboxPlaceholder) {
        // div[data-field-id="_checkbox-claim-understand"]
        const checkboxDiv = document.querySelector('div[data-field-id="_checkbox-claim-understand"]')
        if (checkboxDiv) {
            checkboxDiv.id = 'claim-understand-checkbox'
            checkboxPlaceholder.appendChild(checkboxDiv)
        }
    }

    /**
     * Links to Section B and Section C
     */
    const linkSectionB = document.querySelector("#linkSectionB")
    linkSectionB.addEventListener('click', () => {
        document.querySelector("#transactions").scrollIntoView({ behavior: 'smooth' })
    })
    const linkSectionC = document.querySelector("#linkSectionC")
    linkSectionC.addEventListener('click', () => {
        document.querySelector("#payment-widget").scrollIntoView({ behavior: 'smooth' })
    })

    /**
     * Claim Edits
     * 
     * Class members will have a claim_id if they have previously submitted a 
     * and are returning to edit their claim.
     * 
     * For returning users, tables should be enabled based on the data they already have.
     * For new users, tables are enabled progressively as they fill data.
     */

    // Initial setup - apply standard validation logic for new users
    updateTableDependencies();

    // For returning users, ensure tables are properly enabled
    if (claim.data.claim_id) {
        // IMPORTANT: Always enable Table 2 regardless of Table 1 data (per PM requirement)
        // This allows class members to fill out either OOP or Extraordinary expenses or both
        transactions_2_table.classList.remove('disabled-table');
        const table2Inputs = transactions_2_table.querySelectorAll('input, textarea, button');
        table2Inputs.forEach(input => {
            input.disabled = false;
        });

        // Check if user has any data in Table 2 (Extraordinary)
        let hasTable2Data = false;

        // Check in claim.class_member.claim_transactions - this is where the data is actually stored
        if (claim.class_member?.claim_transactions) {
            hasTable2Data = claim.class_member.claim_transactions.some(trx =>
                (trx.name.includes('Extraordinary') || trx.name.toLowerCase().includes('extraordinary')) &&
                trx.value &&
                trx.value.trim() !== ''
            );
        }

        // In case the data structure is different, also check inputs
        if (!hasTable2Data && claim.inputs?.transactions) {
            hasTable2Data = claim.inputs.transactions.some(input =>
                (input.id.includes('extraordinary') || input.id.includes('extraLoss')) &&
                input.value &&
                input.value.trim() !== ''
            );
        }

        // Also check DOM directly if needed
        if (!hasTable2Data) {
            const extraInputs = document.querySelectorAll('[id*="extraordinary"], [data-label*="Extraordinary"]');
            extraInputs.forEach(input => {
                if (input.value && input.value.trim() !== '') {
                    hasTable2Data = true;
                }
            });
        }

        if (hasTable2Data) {
            // Enable Table 3
            transactions_3_table.classList.remove('disabled-table');
            const table3Inputs = transactions_3_table.querySelectorAll('input, textarea, button');
            table3Inputs.forEach(input => {
                input.disabled = false;
            });
        }
    }



    return claim
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log('[Load class member]...')
    // custom code goes here
    return claim
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log('[Process claim]...')

    /**
     * Prompt: if claim is invalid, then set the following:
     * ```
     * claim.flags.valid = false
     * return claim
     * ```
     */

    /**
     * Required fields:
     * Are required fields filled out?
     */

    const validClaimFields = [
        'checkbox-cash-payment_0',
        'checkbox-id-insurance_0'
    ]

    const validClaimTransactions = [
        'text-desc-oop__1',
        'date-date-oop__1',
        'number-amount-oop__1',
        'text-desc-extraordinary__1',
        'date-date-extraordinary__1',
        'number-amount-extraordinary__1'
    ]

    const fieldsFilled = claim.inputs.fields
        .filter(input => validClaimFields.includes(input.id))
        .some(input => input.checked)

    const transactionsFilled = claim.inputs.transactions
        .filter(input => validClaimTransactions.includes(input.id))
        .some(input => input.value.trim() !== '')

    const requiredFieldsFilled = fieldsFilled || transactionsFilled

    if (!requiredFieldsFilled) {
        const title = "Required Fields Missing"
        const message = "Please ensure all required fields are filled out before proceeding."
        modal(title, message)
        claim.flags.valid = false
        return claim
    }

    /**
     * Supporting documentation
     * Are supporting documents required?
     * Are they provided?
     */
    let documentsRequired = false
    let documentsFound = false

    const requiredTransactionFields = [
        'text-desc-oop__1',
        'date-date-oop__1',
        'number-amount-oop__1',
        'text-desc-extraordinary__1',
        'date-date-extraordinary__1',
        'number-amount-extraordinary__1'
    ]
    documentsRequired = claim.inputs.transactions
        .filter(input => requiredTransactionFields.includes(input.id))
        .some(input => input.value.trim() !== '')

    const uploads = claim.uploads || []
    const files = claim.class_member.claim_files || []
    if (uploads.length > 0 || files.length > 0) {
        documentsFound = true
    }

    if (documentsRequired && !documentsFound) {
        const title = "Supporting Documents Required"
        const message = "Supporting documents are required for this claim. Please upload the necessary documents."
        modal(title, message)
        claim.flags.valid = false
        return claim
    }

    return claim
}
